import {
	Baby,
	Building2,
	Car,
	CreditCard,
	House,
	Landmark,
	Plane,
	RefreshCw,
	Target,
	Umbrella,
} from "lucide-react";
import type {
	CalculatorCatalogEntry,
	CalculatorSection,
} from "web_myplann/Calculators/Types/CalculatorSection";
import { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import {
	CalculatorTypeEnum,
	ClientPortfolioDomainEnum,
} from "web_myplann/Infrastructure/Api/Api";

export const CALCULATOR_CATALOG: Record<
	CalculatorType,
	CalculatorCatalogEntry
> = {
	[CalculatorType.Mortgage]: {
		area: ClientPortfolioDomainEnum.Loans,
		icon: Landmark,
	},
	[CalculatorType.Refinancing]: {
		area: ClientPortfolioDomainEnum.Loans,
		icon: RefreshCw,
	},
	[CalculatorType.AmericanMortgage]: {
		area: ClientPortfolioDomainEnum.Loans,
		icon: Building2,
	},
	[CalculatorType.ConsumerLoan]: {
		area: ClientPortfolioDomainEnum.Loans,
		icon: CreditCard,
	},
	[CalculatorType.PensionAnnuity]: {
		area: ClientPortfolioDomainEnum.PensionProducts,
		icon: Umbrella,
	},
	[CalculatorType.ChildrenSavings]: {
		area: ClientPortfolioDomainEnum.Investments,
		icon: Baby,
	},
	[CalculatorType.GoalAchieve]: { area: "goals", icon: Target },
	[CalculatorType.TravelInsurance]: {
		area: ClientPortfolioDomainEnum.PropertyInsurance,
		icon: Plane,
	},
	[CalculatorType.CarMotoInsurance]: {
		area: ClientPortfolioDomainEnum.PropertyInsurance,
		icon: Car,
	},
	[CalculatorType.PropertyInsurance]: {
		area: ClientPortfolioDomainEnum.PropertyInsurance,
		icon: House,
	},
};

const INSURANCE_SECTION = {
	key: "insurance",
	types: [
		CalculatorType.TravelInsurance,
		CalculatorType.CarMotoInsurance,
		CalculatorType.PropertyInsurance,
	],
} satisfies CalculatorSection;

export const CALCULATOR_SECTIONS: CalculatorSection[] = [
	{
		key: "loansAndHousing",
		types: [
			CalculatorType.Mortgage,
			CalculatorType.Refinancing,
			CalculatorType.AmericanMortgage,
			CalculatorType.ConsumerLoan,
		],
	},
	{
		key: "savingsAndInvestments",
		types: [
			CalculatorType.PensionAnnuity,
			CalculatorType.ChildrenSavings,
			CalculatorType.GoalAchieve,
		],
	},
	INSURANCE_SECTION,
];

export const CALCULATOR_TYPES: CalculatorType[] = CALCULATOR_SECTIONS.flatMap(
	(section) => section.types,
);

export const INSURANCE_CALCULATOR_TYPES = INSURANCE_SECTION.types;

export const CALCULATOR_TYPE_ENUMS: Record<CalculatorType, CalculatorTypeEnum> =
	{
		[CalculatorType.TravelInsurance]: CalculatorTypeEnum.TravelInsurance,
		[CalculatorType.CarMotoInsurance]: CalculatorTypeEnum.CarMotoInsurance,
		[CalculatorType.PropertyInsurance]: CalculatorTypeEnum.PropertyInsurance,
		[CalculatorType.ConsumerLoan]: CalculatorTypeEnum.ConsumerLoan,
		[CalculatorType.Mortgage]: CalculatorTypeEnum.Mortgage,
		[CalculatorType.PensionAnnuity]: CalculatorTypeEnum.PensionAnnuity,
		[CalculatorType.Refinancing]: CalculatorTypeEnum.Refinancing,
		[CalculatorType.AmericanMortgage]: CalculatorTypeEnum.AmericanMortgage,
		[CalculatorType.ChildrenSavings]: CalculatorTypeEnum.ChildrenSavings,
		[CalculatorType.GoalAchieve]: CalculatorTypeEnum.GoalAchieve,
	};
